export default __webpack_public_path__ + "static/media/Vikasbandhu_Five.0f1664b4.jpg";